<template>
  <div class="component-detail-fault">
    <div class="search-hd">
      <el-form
        :inline="true"
        size="mini"
        @submit.native.prevent
      >
      <!-- 导出 -->
      <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="dialogVisible = true"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float:right; margin-right: 8px">
          <custom-date-picker
            @change="getData('init')"
            style="width: 260px"
            v-model="times"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            size="small"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        :data="tableList"
        :index="true"
        :column="tableColumn"
        height="100%"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['enclosure']"
      >
        <template v-slot:enclosure="scope">
          <file-list-download :attachIds="getAttachIds(scope.row)"></file-list-download>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <el-pagination
        border
        v-if="totalRows"
        @size-change="getData('init')"
        @current-change="getData"
        :current-page.sync="formSearch.pageNum"
        :page-size.sync="formSearch.pageSize"
        :page-sizes="pageSizeList"
        layout="sizes, prev, pager, next, slot, jumper"
        :total="totalRows"
      ></el-pagination>
    </div>
    <device-detail-date-datePicker
      v-if="dialogVisible"
      @close="dialogVisible = false"
      @success="exportTable"
      v-model="exportTimer"
    ></device-detail-date-datePicker>
  </div>
</template>

<script>
import customTable from '@/components/customTable.vue';
import apis from '@/utils/apis.js';
import deviceDetailDateDatePicker from '@/components/device_detail_date_datePicker.vue';
import fileListDownload from './fileListDownload.vue';

export default {
  components: {
    customTable,
    fileListDownload,
    deviceDetailDateDatePicker
  },
  props: {
    model: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    bizType() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.bizType : '';
    }
  },
  watch: {
    bizType: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    }
  },
  data() {
    return {
      tableCode: 'device_fault_record',
      formSearch: {
        pageSize: 20,
        pageNum: 1
      },
      times: [],
      tableList: [],
      tableColumn: [],
      totalRows: null,
      attachIds: '',
      exportTimer: '',
      dialogVisible: false
    };
  },
  mounted() {
    this.getTableColumn();
  },
  methods: {
    getAttachIds(row) {
      return this.bizType === 'SC' ? row.customerMedia : row.serviceMedia;
    },
    getData(data) {
      if (data === 'init') {
        this.formSearch.pageNum = 1;
      }
      this.$getJSON(apis.DeviceResumeComponentFaultPage, this.getReqData()).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    getReqData() {
      return {
        ...this.formSearch,
        startDate: this.times && this.times[0] ? this.times[0] : '',
        endDate: this.times && this.times[1] ? this.times[1] : '',
        bodyNum: this.model.bodyNum,
        componentCode: this.model.componentCode
      };
    },
    // 数据导出
    exportTable: function () {
      const startDate = this.exportTimer && this.exportTimer[0] ? this.exportTimer[0] : undefined;
      const endDate = this.exportTimer && this.exportTimer[1] ? this.exportTimer[1] : undefined;
      this.$exportFlie(apis.DeviceResumeFaultExport, {
        bodyNum: this.model.bodyNum,
        componentCode: this.model.componentCode,
        startDate,
        endDate
      }).then(() => { });
    }
  }
};
</script>

<style lang="scss">
.component-detail-fault {
  display: flex;
  flex-direction: column;
  height: 100%;
  .el-form-item {
    margin-bottom: 0 !important;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
